import { Controller } from 'react-hook-form'

import { useFormContextContact } from '../_utils'
import ContactFormField from '../ContactFormField'

const Category = () => {
    const { control } = useFormContextContact()

    return (
        <Controller
            control={control}
            name="category"
            render={({ field, fieldState: { error } }) => (
                <ContactFormField
                    variant="input"
                    label="Catégorie"
                    disabled
                    status={{
                        error,
                        valid: Boolean(field.value),
                    }}
                    size="0.5"
                    dataCyScope="ContactField"
                    {...field}
                    onChange={(e) => {
                        field.onChange(e)
                    }}
                    value={field.value ?? ''}
                    placeholder="Catégorie"
                />
            )}
        />
    )
}

export default Category
